import { render, staticRenderFns } from "./AdManagerOverview.vue?vue&type=template&id=b2a704a0"
import script from "./AdManagerOverview.js?vue&type=script&lang=js&external"
export * from "./AdManagerOverview.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports